import { IIdentifiable } from 'src/app/models/interfaces/identifiable.interface';
import { FormMode } from '../../controls/common/form-mode';
import { DefaultFormContext } from './default-form-context';

export class DefaultDetailContext<ModelInterface extends IIdentifiable, IdType> {
    /**
     * Indique si le formulaire est en mode édition (true) ou en mode consultation (false).
     */
    private _formMode: FormMode = FormMode.Reading;

    public get formMode(): FormMode {
        return this._formMode;
    }

    public set formMode(value: FormMode) {
        this._formMode = value;
        this.formContext.mode = value;
    }

    public editedItemId: IdType = null;

    public formContext: DefaultFormContext<ModelInterface> = new DefaultFormContext<ModelInterface>();
}
